<ng-container *ngIf="!emptyText || _result else emptyTextTemplate">
  <ng-template ngFor [ngForOf]="parts" let-part let-isOdd="odd">
      <ng-container *ngIf="isOdd; else even">
          <span [class]="highlightClass">{{part}}</span>
      </ng-container>
      <ng-template #even>
          <span>{{part}}</span>
      </ng-template>
  </ng-template>
</ng-container>
<ng-template #emptyTextTemplate>
  {{emptyText}}
</ng-template>
